import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Directive({
  selector: '[pcAutoDeletePrevious]',
  standalone: true
})
export class AutoDeletePreviousDirective {
  @Input() index!: number;
  private el = inject(ElementRef<HTMLInputElement>);

  @HostListener('keydown', ['$event'])
  handleBackspace(event: KeyboardEvent) {
    if (event.key === 'Backspace' && this.el.nativeElement.value === '') {
      this.moveToPreviousElement();
    }
  }

  private moveToPreviousElement() {
    // Ascend the DOM from the current input until the parent container (date-container) is found
    const parentContainer = this.el.nativeElement.closest('.date-container');

    if (parentContainer) {
      const elements = Array.from(parentContainer.querySelectorAll('input'));
      if (this.index > 0 && this.index <= elements.length - 1) {
        const previousElement = elements[this.index - 1] as HTMLInputElement;
        previousElement.focus();
      }
    }
  }
}
